export const POWERLOSS_CALCULATION_BAR_SIZE_SCALE = 15;
export const ENERGY_PERFORMANCE_TICK_TOLERANCE = 0.01;
export const ENERGY_PERFORMANCE_STEP_MULTIPLIER = 200;
export const LIFETIME_COSTS_TICK_TOLERANCE = 0.01;
export const LIFETIME_COSTS_STEP_MULTIPLIER = 2500;
